import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import * as Models from 'models';
import { HISTORY_TAGS } from '../HistoryWithExtraStatePlugin';
import { $verifyStyleForList, $applyBrandStyleForList } from './brandStyle';
import { registerCommands } from './commands';
import { $getBulletColorForFirstList, $isSelectionForListItem } from './utils';

export { BULLET_COLOR_COMMAND } from './commands';

export type CustomListOnChangeProps = {
  color: Models.BrandColorMap | undefined;
};

type Props = {
  brandStyle: Models.BrandStyleMap | undefined;
  brandStyleChanged: boolean | undefined;
  onChange: (values: CustomListOnChangeProps | false) => void;
  colors: Models.BrandColorsList;
  editorState: string;
};

export function CustomListPlugin(props: Props): null {
  const { onChange, colors, brandStyle, brandStyleChanged, editorState } = props;
  const [editor] = useLexicalComposerContext();

  useEffect(
    () => registerCommands(editor),
    [editor],
  );

  useEffect(() => {
    // colors are intentionally skipped from deps arg
    editor.update(() => {
      if (brandStyleChanged) {
        return;
      }
      $applyBrandStyleForList(brandStyle, colors);
    }, { tag: HISTORY_TAGS.MERGE, discrete: true });
  }, [editor, brandStyle, brandStyleChanged, editorState]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    editor.update(() => {
      $verifyStyleForList(colors);
    }, { tag: HISTORY_TAGS.MERGE, discrete: true });
  }, [editor, colors]);

  useEffect(() => {
    const readEditorStateAndNotifyChange = (): void => {
      const isList = $isSelectionForListItem();
      if (!isList) {
        onChange(false);

        return;
      }
      onChange({
        color: $getBulletColorForFirstList(colors),
      });
    };
    editor.getEditorState().read(readEditorStateAndNotifyChange);

    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(readEditorStateAndNotifyChange);
    });
  }, [editor, onChange, colors]);

  return null;
}
